import I18n from "common/i18n";
import { usePlaySound } from "common/utils";
import { SelectedImage } from "./types";

interface MessageImagePreviewProps {
  image: SelectedImage;
  onRemove: () => void;
}

export const MessageImagePreview = ({ image, onRemove }: MessageImagePreviewProps) => {
  const play = usePlaySound();

  const handleRemove = () => {
    play();
    onRemove();
  };

  return (
    <div className="absolute bottom-full left-0 right-0 flex-col-el items-center gap-1 px-4 py-4 bg-beige-20/30 backdrop-blur-sm z-0">
      <p className="type-text type-sm text-textcolor-black leading-tight">
        {I18n.t("MSG_CHAT_ATTACHED_IMAGE_LABEL")}
      </p>
      <div className="relative w-[200px] h-[200px]">
        <img src={image.url} alt="" className="w-full h-full object-contain" />
        <button
          onClick={handleRemove}
          className="absolute -top-3 -right-3 w-8 h-8 rounded-full bg-red-80 border-none cursor-pointer flex items-center justify-center"
        >
          <span className="material-symbols-outlined text-white !text-[20px]">close</span>
        </button>
      </div>
    </div>
  );
};
